import { render } from "./ButtonGroup.vue?vue&type=template&id=5ce50826&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import "./ButtonGroup.vue?vue&type=style&index=0&id=5ce50826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce50826"]])

export default __exports__